import { Link } from '@zorro/design-system/v2/Link';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Group } from '@zorro/web/design-system';
import { useTextOverflow } from '@zorro/web/ui-utils';
import { HTMLAttributeAnchorTarget, ReactNode } from 'react';

type Props = {
  href: string;
  value: string;
  leftSection?: ReactNode;
  maw?: string;
  target?: HTMLAttributeAnchorTarget;
  isMasked?: boolean;
};

export function DynamicOverflowCell({
  href,
  value,
  leftSection,
  maw = '10.5rem',
  target = '',
  isMasked = true,
}: Props) {
  const { isTextOverflowing, textRef } =
    useTextOverflow<HTMLSpanElement>(value);

  return (
    <Group gap="xs" wrap="nowrap">
      {leftSection}
      <Tooltip
        label={value}
        maw={500}
        position="top"
        disabled={!isTextOverflowing}
      >
        <Link
          labelRef={textRef}
          href={href}
          prefetch={false}
          isMasked={isMasked}
          variant="secondary"
          shouldTruncate
          maw={maw}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          rightSection={null}
        >
          {value}
        </Link>
      </Tooltip>
    </Group>
  );
}
